const resources = {
    emailAddress: 'Email Address',
    asMText: 'If you no longer wish to receive the notification, enter the email address you wish to remove and click “Remove”.',
    asMBText: 'Remove',
    nsMText: 'To receive the in stock notification email, just enter your email address and click “Email Me”.',
    nsMBText: 'Email Me',
    empty: 'Please enter your email address.',
    invalid: 'Please enter an e-mail address in the format username@domain.com.',
    subscribe: 'Your in stock notification email will be sent to ',
    remove: 'You are no longer scheduled to receive the email when in stock notification.',
    emailMe: 'Email me when available'
};

module.exports = function getResource(label) {
    return resources[label];
};
